import { render, staticRenderFns } from "./SeriesTab.vue?vue&type=template&id=50126e74&"
import script from "./SeriesTab.vue?vue&type=script&lang=ts&"
export * from "./SeriesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports